import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                // Determine if we need to wait for render (rare but possible) or just fallback
                // For now, if element not found immediately, maybe it's not rendered yet.
                // But usually on sync render it works.
                // Let's retry once with timeout for safety?
                setTimeout(() => {
                    const el = document.getElementById(hash.substring(1));
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return null;
}
